import { render, staticRenderFns } from "./SumPaymentList.vue?vue&type=template&id=0bba2f90&"
import script from "./SumPaymentList.vue?vue&type=script&lang=js&"
export * from "./SumPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports